import React from "react";
import PropTypes from "prop-types";
import "./MerchandisingFilters.scss";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MerchandisingFiltersItem from "app/pages/Merchandising/MerchandisingFilters/MerchandisingFiltersItem";
import {
	sendTagOnMerchandisingProductsFilter,
	sendTagOnMerchandisingProductsFilterRemove,
} from "app/utils/analytics";
import {
	setMerchProductsFilter,
	unsetMerchProductsFilter,
} from "app/pages/Merchandising/merchandisingActionCreators";

class MerchandisingFilters extends React.PureComponent {
	constructor() {
		super();
		this.onFilterSelect = this.onFilterSelect.bind(this);
	}

	onFilterSelect(merchandisingTopic) {
		if (this.props.activeFilter === merchandisingTopic) {
			this.props.unsetMerchProductsFilter();
			this.props.onFilterSelect(undefined);
			sendTagOnMerchandisingProductsFilterRemove(merchandisingTopic);
		} else {
			this.props.setMerchProductsFilter(merchandisingTopic);
			this.props.onFilterSelect(merchandisingTopic);
			sendTagOnMerchandisingProductsFilter(merchandisingTopic);
		}
	}

	render() {
		const { merchandisingTopics, activeFilter } = this.props;

		return (
			<div className="merchandising-filters">
				{merchandisingTopics.map((merchandisingTopic, index) => {
					return (
						<MerchandisingFiltersItem
							key={index}
							active={activeFilter === merchandisingTopic}
							onFilterSelect={this.onFilterSelect}
							label={merchandisingTopic}
						/>
					);
				})}
			</div>
		);
	}
}

MerchandisingFilters.propTypes = {
	merchandisingTopics: PropTypes.arrayOf(PropTypes.string),
	setMerchProductsFilter: PropTypes.func,
	unsetMerchProductsFilter: PropTypes.func,
	onFilterSelect: PropTypes.func,
	activeFilter: PropTypes.string,
};

MerchandisingFilters.defaultProps = {
	merchandisingTopics: [],
	onFilterSelect: () => {},
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ setMerchProductsFilter, unsetMerchProductsFilter }, dispatch);
};

export default connect(
	null,
	mapDispatchToProps
)(MerchandisingFilters);
